import { BButton, BCard } from '../../../components/ui/generic';
import { useDocuments } from '../../../hooks/Documents';
import BLoader from '../../../components/BLoader';
import { useHeader } from '../../../context/HeaderContext';
import { useEffect, useState } from 'react';
import Document from '../../../components/Cards/Document';
import BDrawer from '../../../components/BDrawer';
import Add from '../../../components/Documents/Add';

const DashboardDocuments = () => {
  const [drawer, setDrawer] = useState(false);

  const { setTitle, setDescription } = useHeader();
  useEffect(() => {
    setTitle('Vos documents');
    setDescription('Déposez ou téléchargez vos documents');
  }, [setDescription, setTitle]);
  const { data, isSuccess, isLoading, isError, error } = useDocuments();

  if (isLoading) return <BLoader />;
  if (isError)
    return (
      <div className={'grid w-full gap-4 lg:grid-cols-2'}>
        <BCard>
          <BCard.Header title={'Documents'} withTitle>
            <span />
          </BCard.Header>
          <BCard.Body>Une erreur est survenue, {error.message}</BCard.Body>
        </BCard>
      </div>
    );
  if (isSuccess) {
    return (
      <div className={'grid w-full gap-4 lg:grid-cols-2'}>
        <BDrawer open={drawer} setOpen={setDrawer}>
          <Add callback={() =>setDrawer(false)} />
        </BDrawer>
        <BCard>
          <BCard.Header title={'Documents personnels'} withTitle>
            <span />
            <BButton label={'+'} size={'xs'} onClick={() => setDrawer(true)} />
          </BCard.Header>
          <BCard.Body>
            {data.map((d, idx) => (
              <Document file={d} key={idx} />
            ))}
          </BCard.Body>
        </BCard>
      </div>
    );
  }
};

export default DashboardDocuments;
